module.exports = __webpack_public_path__ + "img/sixpackcarrier05.27aaebc2.jpg";